<p-toast position="top-right"></p-toast>
<p-confirmDialog class="logOut" key="combine-confirm-dialog"></p-confirmDialog>

<div class="wrapper" id="main-wrapper">
  <div class="nav">
    <app-navbar></app-navbar>
  </div>
  <div class="main-container">
    <router-outlet></router-outlet>
    <div class="whats-icon-mobile">
      <div class="contact-bubble contact-bubble--whatsapp">
        <span class="bubble-text">¡Envíanos un mensaje!</span>
        <a
          href="/gracias/whatsapp"
          routerLink="/gracias/whatsapp"
          aria-label="Escríbenos por WhatsApp">
          <i class="pi pi-whatsapp"></i>
        </a>
      </div>
      <div class="contact-bubble contact-bubble--phone">
        <span class="bubble-text">Llámanos ahora</span>
        <a
          href="/gracias/telefono"
          routerLink="/gracias/telefono"
          aria-label="Llámanos por teléfono">
          <img src="/assets/images/icons/phone.png" alt="Icono Telefono">
        </a>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
